module.exports = __webpack_public_path__ + "static/media/joker-king.a533b1bc.gif";